/**
 * Hook to manage DataDog RUM user context when auth state changes
 */

import { useEffect } from 'react';
import {
  clearDatadogRumUserContext,
  initializeDatadogRum,
  setDatadogRumUserContext,
} from '../config/dd-rum';
import { useWidgetAuth } from '../context/AuthContext';

/**
 * Automatically manages DataDog RUM user context when auth state changes
 * Call this hook once in your main app component
 */
export const useDatadogRumUserContext = (): void => {
  const { user, isAuthenticated } = useWidgetAuth();

  useEffect(() => {
    initializeDatadogRum();
  }, []);

  useEffect(() => {
    if (isAuthenticated && user) {
      setDatadogRumUserContext(user);
    } else if (!isAuthenticated) {
      // User logged out - clear their context
      clearDatadogRumUserContext();
    }
  }, [isAuthenticated, user]);
};
